import React, { CSSProperties, HTMLAttributes } from "react";
import { IModulePager } from "Hooks";
import useMediaBreakpointUp from "Hooks/useMediaBreakpointUp";
import ModulePagerDesktop from "./ModulePagerDesktop";
import ModulePagerMobile from "./ModulePagerMobile";

export interface ModulePagerProps<T> extends HTMLAttributes<HTMLDivElement> {
   pager: IModulePager,
   items: ReadonlyArray<T>,
   renderItem: (item: T, style: CSSProperties) => React.ReactElement
}

const ModulePager/* : React.FC<ModulePagerProps<T>> */ = <T,>({ ...rest }: React.PropsWithChildren<ModulePagerProps<T>>) => {
   const isDesktop = useMediaBreakpointUp("md");

   return isDesktop
      ? <ModulePagerDesktop {...rest} />
      : <ModulePagerMobile {...rest} />
};

export default ModulePager;